 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_DEDICATION from '@/components/html/03_Dedication'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_LIST_OF_ILLUSTRATIONS from '@/components/html/05_List_of_Illustrations'
 import HTML06_AUTHOR_S_NOTE_ON_NAMES from '@/components/html/06_Author_s_Note_on_Names'
 import HTML07_THE_HUXLEY_FAMILY_TREE from '@/components/html/07_The_Huxley_Family_Tree'
 import HTML08_INTRODUCTION from '@/components/html/08_Introduction'
 import HTML09_PART_I__GENEALOGIES from '@/components/html/09_PART_I__Genealogies'
 import HTML10_1__GENERATIONS__THE_HUXLEYS__182 from '@/components/html/10_1__Generations__The_Huxleys__182'
 import HTML11_2__TRUSTEES_OF_EVOLUTION__THE_IN from '@/components/html/11_2__Trustees_of_Evolution__The_In'
 import HTML12_3__MALADY_OF_THOUGHT__HUXLEY_MIN from '@/components/html/12_3__Malady_of_Thought__Huxley_Min'
 import HTML13_PART_II__ANIMALS from '@/components/html/13_PART_II__Animals'
 import HTML14_4__CREATURES_OF_THE_SEA_AND_SKY from '@/components/html/14_4__Creatures_of_the_Sea_and_Sky'
 import HTML15_5__ANIMAL_POLITICS__FROM_CRUELTY from '@/components/html/15_5__Animal_Politics__From_Cruelty'
 import HTML16_6__PRIMATES__APES_AND_THE_HUXLEY from '@/components/html/16_6__Primates__Apes_and_the_Huxley'
 import HTML17_PART_III__HUMANS from '@/components/html/17_PART_III__Humans'
 import HTML18_7__THE_MAN_FAMILY__SAPIENS_OF_TH from '@/components/html/18_7__The_Man_Family__Sapiens_of_th'
 import HTML19_8__HUMAN_DIFFERENCE__SAPIENS_IN from '@/components/html/19_8__Human_Difference__Sapiens_in'
 import HTML20_9__TRANSHUMANS__SAPIENS_OF_THE_E from '@/components/html/20_9__Transhumans__Sapiens_of_the_E'
 import HTML21_PART_IV__SPIRITS from '@/components/html/21_PART_IV__Spirits'
 import HTML22_10__OTHER_WORLDS__THE_RE_ENCHANT from '@/components/html/22_10__Other_Worlds__The_Re_enchant'
 import HTML23_EPILOGUE__BIRTH__DEATH__AFTERLIV from '@/components/html/23_Epilogue__Birth__Death__Afterliv'
 import HTML24_ACKNOWLEDGEMENTS from '@/components/html/24_Acknowledgements'
 import HTML25_NOTES from '@/components/html/25_Notes'
 import HTML26_INDEX from '@/components/html/26_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_List_of_Illustrations",
 			"name" : "html/05_List_of_Illustrations",
 			"component" : HTML05_LIST_OF_ILLUSTRATIONS
 		},
 		{
 			"path" : "/html/06_Author_s_Note_on_Names",
 			"name" : "html/06_Author_s_Note_on_Names",
 			"component" : HTML06_AUTHOR_S_NOTE_ON_NAMES
 		},
 		{
 			"path" : "/html/07_The_Huxley_Family_Tree",
 			"name" : "html/07_The_Huxley_Family_Tree",
 			"component" : HTML07_THE_HUXLEY_FAMILY_TREE
 		},
 		{
 			"path" : "/html/08_Introduction",
 			"name" : "html/08_Introduction",
 			"component" : HTML08_INTRODUCTION
 		},
 		{
 			"path" : "/html/09_PART_I__Genealogies",
 			"name" : "html/09_PART_I__Genealogies",
 			"component" : HTML09_PART_I__GENEALOGIES
 		},
 		{
 			"path" : "/html/10_1__Generations__The_Huxleys__182",
 			"name" : "html/10_1__Generations__The_Huxleys__182",
 			"component" : HTML10_1__GENERATIONS__THE_HUXLEYS__182
 		},
 		{
 			"path" : "/html/11_2__Trustees_of_Evolution__The_In",
 			"name" : "html/11_2__Trustees_of_Evolution__The_In",
 			"component" : HTML11_2__TRUSTEES_OF_EVOLUTION__THE_IN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js